import React, { Component, ReactFragment } from 'react';
import cs from 'classnames'
import {
  Typography,
  Theme,
  createStyles,
  WithStyles,
  withStyles,
  Card,
  CardContent,
  Grid,
  Button,
  Avatar,
} from '@material-ui/core';
import _ from 'lodash';
import { fade } from '@material-ui/core/styles/colorManipulator';
// import { getTimeAgo } from '../../../utils';
import dateService from '../../common/services/dateService';
import ACL from '../../acl/components/ACL';

const styles = (theme: Theme) => createStyles({
  ml1x: {
    marginLeft: theme.spacing.unit * 2,
  },
  listTypo: {
    fontSize: '0.8em',
  },
  bold: {
    fontWeight: "bold",
  },
  bigAvatar: {
    margin: 10,
    width: 60,
    height: 60,
  },
  colorAvatar: {
    width: '60px',
    height: '60px',
    margin: '10px',
    color: '#fff',
  },
  addRoleCardImage: {
    opacity: 0.7,
  },
  addRoleCardName: {
    opacity: 0.7,
  },
  addRoleCardButton: {
    marginRight: theme.spacing.unit * 2,
    '& > button': {
      backgroundColor: theme.palette.common.white,
      border: `1px dashed ${theme.palette.grey[500]}`,

    }
  },
  addRoleCard: {
    backgroundColor: fade(theme.palette.background.default, 0.54),
    borderRadius: theme.spacing.unit / 2,
    '& div': {
      backgroundColor: fade(theme.palette.background.default, 0.54),
    }
  },
});


interface UserCardProps extends WithStyles<typeof styles> {
  name: string,
  role: string,
  lastActivityAt: string,
  imgSrc: string,
}


const UserCard = (props: UserCardProps) => {

  const { classes,role,imgSrc,name,lastActivityAt } = props;
  return (
    // _.isEmpty(role)
      // ?
      // <Grid container className={classes.addRoleCard} alignItems="center" spacing={8}>
      //   <Grid item>
      //     <Avatar alt={`Profile ${name}`} src={imgSrc} className={classes.bigAvatar} />
      //   </Grid>
      //   <Grid item xs className={classes.addRoleCardName}>
      //     <Typography variant="subtitle1" className={cs(classes.bold, classes.listTypo)}>{name}</Typography>
      //   </Grid>
      //   <ACL
      //     layerType={['USER']}
      //     accessType={['UPDATE', 'EDIT']}
      //   >
      //     <Grid item xs="auto" className={classes.addRoleCardButton}>
      //       <Button variant="contained" color="default"
      //       >
      //         Activate User
			// 				</Button>
      //     </Grid>
      //   </ACL>
      // </Grid>
      // :
      <Grid container alignItems="center" spacing={8} >
        <Grid item>
          {!_.isEmpty(imgSrc) && !_.isUndefined(imgSrc) ?
            (<Avatar alt={`Profile ${name}`} src={imgSrc} className={classes.bigAvatar} />)
            : (<Avatar className={classes.colorAvatar}></Avatar>)
          }
        </Grid>
        <Grid item xs="auto">
          <Typography variant="subtitle1" className={cs(classes.bold, classes.listTypo)}>{name == "undefined undefined" ? "Unknown":name}</Typography>
          <Typography variant="subtitle1" className={classes.listTypo}>
          {
            !_.isEmpty(role) ?
              role :' -'
          }
          </Typography>
          <Typography variant="subtitle1" className={classes.listTypo}>Last Activity: 
          {!_.isEmpty(lastActivityAt) ?
          ` ${dateService.getTimeAgo(lastActivityAt)} ago`:' NA'
          }
          </Typography>
        </Grid>
      </Grid>

  )
}
export default withStyles(styles)(UserCard);